module.exports = __webpack_public_path__ + "static/media/missions.23528526.svg";